import { ChatApp } from './app';

document.addEventListener('DOMContentLoaded', () => {
    new ChatApp();
});
